<template>
    <div>
        <!-- TITLE -->
        <h5 class="mt-2">
            {{ 'ACCEPT_MANUALLY_MESSAGE' | translate }}
        </h5>

        <div class="mt-4">

            <!-- REASON -->
            <div class="form-group" id="policyCaseAcceptManually">
                <label id="policyCaseAcceptManually-label">{{ 'REASON' | translate }}</label>
                <input class="reason-input" type="text" id="policyCaseAcceptManually-input" v-model="reason" maxlength="50" />
            </div>

            <!-- CONFIRM BUTTON -->
            <button class="btn btn-block btn-success mt-5" :disabled="!reason" @click="acceptManually"
                id="policyCaseAcceptManually-confirm-button">{{ 'ACCEPT_MANUALLY' | translate }}</button>
        </div>
    </div>
</template>
    
    <script>
    
    export default {
      components: { },
      data: function () {
        return {
          reason: null
        }
      },
      computed: {
      },
      methods: {
        acceptManually() {
          this.$emit('execute-case-accept-manually', this.reason);
        }
      }
    }
    </script>
    
    <style scoped>
    .reason-input{
      width: 100%;
    }
    </style>
    


// WEBPACK FOOTER //
// src/components/case/PolicyCaseAcceptManually.vue